import React from "react";
import { useSelector } from "react-redux";
import Amendment from "../../../commonComponents/Amendment";
import { useAmendmentReason } from "../../hooks/useAmendmentReason";

const AmendmentReasons = ({isDisabled}) => {
  const methodList=useAmendmentReason({containerKey:"header"})
  const amendReasonTypeList =useSelector((state) => state.DropDownValues.reasonCodes);
  
  return (
   <Amendment formConfig={{isDisabled}} {...methodList} amendReasonTypeList={amendReasonTypeList} />
   );
}
export default React.memo(AmendmentReasons)
